// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ae7e5dc703b5223ee86b","293":"2f46d227a064091ba634","518":"e0dcd9067f6b6a7a44cb","779":"86f4c92e31df33f53808"}[chunkId] + ".js";
};